/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated';
import { createParserClass } from '../../factoriesAny.js';
export var ParserDependencies = {
  parseDependencies: parseDependencies,
  createParserClass: createParserClass
};